// src/App.js
import React from 'react';
import Dashboard from './components/Dashboard/Dashboard';
import './App.css';
import { ThemeProvider, ThemeSwitcher } from './ThemeSwitcher';

function App() {
  return (
      <ThemeProvider>
        <div className="app">
          <main className="app-main">
            <Dashboard />
          </main>

          <footer className="app-footer">
            <p>&copy; 2025 Data Visualization Dashboard</p>
          </footer>
          <ThemeSwitcher />
        </div>
      </ThemeProvider>
  );
}

export default App;